import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const LogoutButton: React.FC = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <button  className="theme-btn" onClick={handleLogout}>
      <i className="lni lni-exit"></i>
      <span>Logout</span>
    </button>
  );
};

export default LogoutButton; 